import { createFileRoute } from "@tanstack/react-router";
import { OrganizationAdminClassDetailPage } from "./-components/class-detail-page";
import { ensureRouteQueryData } from "@/lib/route-loader";
import { parseClassIdParams } from "@/lib/route-params";
import { getAdminClassGetAdminClassDetailQueryOptions } from "@/orval/admin-class";
import { z } from "zod";

const classDetailSearchSchema = z.object({
  tab: z.string().optional(),
});

export const Route = createFileRoute("/_app/organizations/$organizationId/admin/_classes/classes_/$classId")({
  params: {
    parse: parseClassIdParams,
  },
  validateSearch: classDetailSearchSchema,
  loader: ({ params, ...loaderContext }) =>
    ensureRouteQueryData(
      loaderContext,
      getAdminClassGetAdminClassDetailQueryOptions(params.organizationId, params.classId),
    ),
  component: RouteComponent,
});

function RouteComponent() {
  const { classId, organizationId } = Route.useParams();
  const { tab = "details" } = Route.useSearch();

  return <OrganizationAdminClassDetailPage classId={classId} organizationId={organizationId} tab={tab} />;
}
